import React from "react";
import { Container } from "./styles";

const PresetContainer = ({ children }) => {
  return <Container>{children}</Container>;
};

export default PresetContainer;
